import {cleanTitle, defaultImageName} from '../../smartpak/misc.js';
import $ from 'jquery';
import ko from 'knockout';
import wishList from '../productclasspage/wishlist.js';

var utils = ko.utils;

function PiperQuiz(obj) {
    var $refresh = $('#refresh'),
        $piper = $('#piperSections'),
        $footer = $('#footerMenu'),
        $visitedPage = $('#visitedPg'),
        // eslint-disable-next-line no-empty-function
        error = function() {},
        arr = [],
        win = window;

    this.sections = ko.observableArray(
        utils.arrayMap(obj.sections, function(section) {
            return section;
        })
    );

    this.hasProductsAvailable = ko.observable(false);
    this.products = ko.observableArray([]);

    this.getHash = function() {
        var hash = win.location.hash;

        hash = hash.replace(/#/gi, '');

        return hash === '' ? 'Home' : hash;
    };

    this.getSectionView = function() {
        var sectionID,
            hashId = 'Piper_' + this.getHash(),
            $section = $('.sectionName');

        $.each(
            $section,
            function(i, val) {
                sectionID = $(val).attr('id');
                if (sectionID === hashId) {
                    this.loadProductView(sectionID);
                } else {
                    $('#' + sectionID).addClass('jsHide');
                }
            }.bind(this)
        );
    };

    this.loadProductView = function(section) {
        var $piperID = $('#' + section),
            results = $piperID.find('.prodID');

        this.hasProductsAvailable(false);
        $piperID.removeClass('jsHide');
        this.threeAnswerLayout($piperID);

        if (results.length > 0) {
            this.hasProductsAvailable(true);
            $('#recentViewList li.jcarousel-item')
                .not(':first')
                .remove();
            this.getProductData(results);
        }
    };

    this.removeScripts = function(input) {
        var searchWord = new RegExp(input);

        $.each($('script'), function(i, val) {
            var valScript = $(val).attr('src');

            if (searchWord.test(valScript)) {
                $(val).remove();
            }
        });
    };

    this.threeAnswerLayout = function($sectionID) {
        var divLen = $sectionID.find('.answer div').length,
            $answer = $sectionID.find('.answer'),
            $layout = $sectionID.find('.btnLayout');

        if (divLen > 2) {
            $answer.addClass('answerThree');
            $layout.addClass('btnLayoutThree');
        }
    };

    this.formatProductReviews = function(data) {
        var prodData = this.grabProductData(data);

        this.products(prodData);
        this.initateMedia();
        this.multiplePiperResults();
        $('#productItem').removeClass('jsHide');
    };

    this.grabProductData = function(data) {
        var dataItems = $.map(data, function(item) {
            return $.extend(item, {
                Title: cleanTitle(item.Title),
                thumbnail: defaultImageName(item, item.ImagePath) + '?width=120',
                productId: item.Id,
                socialUrl: '//www.smartpakequine.com' + item.Url,
                Url: item.Url
            });
        });

        return dataItems;
    };

    this.initateMedia = function() {
        wishList.init();
    };

    this.multiplePiperResults = function() {
        var $recently = $('#recentViewList'),
            $recentViewList = $recently.find('li.jcarousel-item'),
            $socialLinks = $recently.find('.socialLinks'),
            $productItem = $('#productItem');

        if ($recentViewList.length > 1) {
            $recentViewList.addClass('multipleProduct');
            $socialLinks.find('#socialIcons').addClass('multipleProduct');
            $socialLinks.addClass('multipleProduct');
            $socialLinks.find('.socialAction').addClass('multipleProduct');
            $productItem.addClass('multipleProduct');
        } else {
            $recentViewList.removeClass('multipleProduct');
            $socialLinks.find('#socialIcons').removeClass('multipleProduct');
            $socialLinks.removeClass('multipleProduct');
            $socialLinks.find('.socialAction').removeClass('multipleProduct');
            $productItem.removeClass('multipleProduct');
        }
    };

    this.successProductReviews = function(data) {
        if (data && data.length) {
            this.formatProductReviews(data);
            smartPak.recentlyViewedProducts.loadBvReviewStars('.quizReviewStars');
        }
    };



    this.getProductData = function(productIDs) {
        var DELIMITER = '!',
            ids = $(productIDs).val();

        return smartPak.api.product
            .getProductClassDTOList(ids.split(DELIMITER))
            .done(this.successProductReviews.bind(this))
            .fail(error);
    };

    this.hideOnHomePage = function() {
        if (this.getHash() === 'Home') {
            $refresh.addClass('jsHide');
            $piper.removeClass('lineupRefresh');
            $footer.addClass('jsHide');
            arr = [];
        } else {
            $refresh.removeClass('jsHide');
            $piper.addClass('lineupRefresh');
        }
    };

    this.removeFromArray = function(array, section) {
        var total = array.length,
            spot = $.inArray(section, array),
            leftover;

        if (spot >= 0) {
            leftover = total - spot;
            array.splice(spot, leftover);
        }

        return array;
    };

    this.checkForPiperDistinction = function(piper) {
        var hashedValue = 'Piper_' + piper,

        selectedOption = obj.sections.find(option =>{
            return option.name === hashedValue;
        }),
        response = selectedOption.response;

        return response;
    };

    this.replacePiperType = function(type, copy, piper) {
        var removeContent = new RegExp(piper);

        return type > 0 ? copy.replace(removeContent, '') : copy;
    };

    this.populateVisitedLinks = function() {
        var backBtn = '',
            hash = this.getHash();

        arr = this.removeFromArray(arr, hash);
        arr.push(hash);

        $.grep(
            arr,
            function(val) {
                var btnText = this.checkForPiperDistinction(val);
                backBtn +=
                    '<a href="#' + val + '" class="primary button returnBtn" data-size="sm">' + btnText.replace(/_/gi, ' ') + '</a>';
            }.bind(this)
        );

        $visitedPage.html('');
        $(backBtn).appendTo('#visitedPg');
        $footer.removeClass('jsHide');
    };

    $(win).on(
        'popstate',
        function() {
            this.populateVisitedLinks();
            this.hideOnHomePage();
            this.getSectionView();
        }.bind(this)
    );
}

export default PiperQuiz;
